import _ from 'lodash'

import { SET_SERVICE_LIST } from './mutation-types'

export default {
  [SET_SERVICE_LIST](state, serviceList) {
    state.serviceList = _.cloneDeep(serviceList)
  },
}



// WEBPACK FOOTER //
// ./src/store/serviceStore/mutations.js